import Link, { LinkProps } from 'next/link'
import React from 'react'

import {
  SectionIconLink as UISectionIconLink,
  BaseSectionIconLinkProps as UIBaseSectionIconLinkProps,
} from '~shared/ui/SidebarNavigation'
import Tooltip from '~shared/ui/Tooltip'

type BaseSectionIconLinkProps = UIBaseSectionIconLinkProps &
  Prefer<LinkProps, React.AnchorHTMLAttributes<HTMLAnchorElement>>

interface SectionIconLinkPropsProps extends BaseSectionIconLinkProps {
  title: string
}

function SectionIconLink({ title, ...props }: SectionIconLinkPropsProps) {
  return (
    <Tooltip content={title} trigger="hover" delay={400} placement="right">
      <UISectionIconLink<LinkProps> component={Link} {...props} />
    </Tooltip>
  )
}

export default SectionIconLink
